import { Component, Input } from '@angular/core';
import { Select } from 'primeng/select';
import { InputKeyValuesInterface } from '../../../types/interfaces/input.interface';
import { FormControl, FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-input-key-values',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Select,
  ],
  templateUrl: './input-key-values.html',
  styleUrl: './input-key-values.css',
})
export class InputKeyValues {
  @Input()
  public formData!: InputKeyValuesInterface;


  public draftKey: string = '';
  public draftValue: string = '';

  public get control(): FormControl<Record<string, string>> {
    const control = this.formData.formGroup?.get(this.formData.id);

    if (!control) {
      throw new Error(`Control "${this.formData.id}" wurde nicht gefunden.`);
    }

    return control as FormControl<Record<string, string>>;
  }

  public get value(): Record<string, string> {
    return this.control.value ?? {};
  }

  public get entries(): Array<{ key: string; value: string }> {
    return Object.entries(this.value).map(([key, value]) => ({ key, value }));
  }

  public get availableKeys(): string[] {
    const predefined = this.formData.predefinedKeys ?? [];
    const usedKeys = new Set(Object.keys(this.value));

    return predefined.filter((key) => !usedKeys.has(key));
  }

  public get usesPredefinedKeys(): boolean {
    return !!this.formData.predefinedKeys?.length;
  }

  public addEntry(): void {
    console.log('addEntry');
    console.log(this.draftKey, this.draftValue);
    const key: string = this.draftKey.trim();
    const value: string = this.draftValue.trim();

    if (!key || !value) return;

    if (this.usesPredefinedKeys && !this.formData.predefinedKeys?.includes(key)) {
      return;
    }

    const nextValue: Record<string, string> = {
      ...this.value,
      [key]: value,
    };

    this.control.setValue(nextValue);
    this.control.markAsDirty();
    this.control.markAsTouched();

    this.draftKey = '';
    this.draftValue = '';
  }

  public removeEntry(key: string): void {
    const nextValue = { ...this.value };
    delete nextValue[key];

    this.control.setValue(nextValue);
    this.control.markAsDirty();
    this.control.markAsTouched();
  }

  public updateEntryValue(key: string, value: string): void {
    this.control.setValue({
      ...this.value,
      [key]: value,
    });

    this.control.markAsDirty();
  }

  public onInput(event?: Event): void {
    this.formData.onInput?.(event);
  }
}
